import React, { useRef, useState } from 'react'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Slider from 'react-slick'
import SliderWrapper from './_SlickSlider'
import CustomImage from '../../customImage/customImage'
import AddSection from '../addSection'
import useTemplateHook from '../templateHook'
import { isEmpty } from 'lodash'
import NextArrow from '../../../assets/nextArrow'
import DeleteModal from '../../DeleteModal/DeleteModal'
import EditMenu from '../editMenu'

const QuadruplePromoCarousel = ({
  componentData,
  modifyData,
  setModalState,
  isEdit,
  onSwap,
  onDelete,
  onCopy,
  theme,
  onAdd,
}) => {
  const sliderRef = useRef(null)
  const { LeftArrow, RightArrow, EditIcon, getTemplateImage } = useTemplateHook()
  const { data, id } = componentData
  const [hoverState, setHoverState] = useState('')
  const [deleteModal, setDeleteModal] = useState(false)
  const [selectedCardIndex, setSelectedCardIndex] = useState('')

  function SampleNextArrow(props) {
    const { className, style, onClick } = props
    return (
      <div
        className={className}
        style={{
          ...style,
          display: 'block',
          background: 'transparent',
          width: window.innerWidth <= 768 ? '24px' : '46px',
          height: window.innerWidth <= 768 ? '24px' : '46px',
          position: 'absolute',
          top: '40%',
          right: window.innerWidth < 768 ? '60px' : '0px',
          transform: 'translateY(-50%)',
          zIndex: '10',
          content: `url(${RightArrow})`,
        }}
        onClick={onClick}
      >
        <img
          src={RightArrow}
          alt="Next"
          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        />
      </div>
    )
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props
    return (
      <div
        className={className}
        style={{
          ...style,
          display: 'block',
          background: 'transparent',
          width: window.innerWidth <= 768 ? '24px' : '46px',
          height: window.innerWidth <= 768 ? '24px' : '46px',
          position: 'absolute',
          top: '40%',
          left: '0px',
          transform: 'translateY(-50%)',
          zIndex: '10',
          content: `url(${LeftArrow})`,
        }}
        onClick={onClick}
      >
        <img
          src={LeftArrow}
          alt="Previous"
          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        />
      </div>
    )
  }

  const handleHoverItems = (name) => {
    if (!isEdit) return
    setHoverState(name)
  }

  const getStyleValue = (parentKey, childKey, defaultValue) => {
    if (!data?.style_config) {
      return defaultValue ? defaultValue : ''
    }

    let tempArr = data?.style_config[parentKey]?.data.filter((info) => info.key === childKey)

    return !isEmpty(tempArr) ? (tempArr[0].value ? tempArr[0].value : defaultValue) : defaultValue
  }

  const handleModal = (cardInfo, type, cardIndex, isEdit) => {
    setModalState({
      keyID: id,
      modalData: cardInfo,
      type: type,
      cardIndex: cardIndex,
      isEdit,
    })
  }

  const handleAddModal = () => {
    onAdd({
      keyID: id,
      modalData: data,
    })
  }

  const settings = {
    dots: false,
    autoplaySpeed: 2500,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    pauseOnHover: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  }

  const deleteCard = (index) => {
    setSelectedCardIndex(index)
    setDeleteModal(true)
  }

  const onDeleteCard = () => {
    let tempdata = data
    tempdata?.parent_card.splice(selectedCardIndex, 1)
    modifyData(id, tempdata)
    setDeleteModal(false)
    setSelectedCardIndex('')
  }

  return (
    <div
      className={`w-full py-6 px-4  relative  ${isEdit && hoverState && 'component-hover-class'} `}
      onMouseOver={() => handleHoverItems(`TOP`)}
      onMouseLeave={() => handleHoverItems('')}
      style={{ background: getStyleValue('component_color', 'component_color', '') }}
    >
      {isEdit && hoverState.length > 0 && (
        <EditMenu
          onDelete={() => onDelete(id)}
          onMoveUp={() => onSwap(id, 'up')}
          onMoveDown={() => onSwap(id, 'down')}
          onCopy={() => onCopy(id)}
        />
      )}
      <div className="py-10" style={{ maxWidth: '1269px', margin: '0 auto' }}>
        <div className="w-full relative">
          <h2
            style={{
              color: getStyleValue('component_color', 'component_heading_color', ''),
              fontFamily: getStyleValue('component_color', 'font', ''),
              textAlign: getStyleValue('component_color', 'alignment', ''),
            }}
            className={`text-xl   mb-3 font-semibold w-full relative ${
              isEdit && hoverState === 'HEADING' && 'component-hover-class pr-10'
            } ${getStyleValue('component_color', 'font_format', '')}`}
            onMouseOver={(e) => {
              e.stopPropagation()
              handleHoverItems('HEADING')
            }}
            onMouseLeave={(e) => {
              e.stopPropagation()
              handleHoverItems('TOP')
            }}
          >
            {data?.title}
            {isEdit && hoverState === 'HEADING' && (
              <div
                className="absolute h-[25px] w-[25px] rounded-full bg-[#2172eb] top-1 -right-3 flex justify-center items-center cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation()
                  handleModal({ title: data?.title }, 'HEADING', 0, true)
                }}
              >
                <img src={EditIcon} className="w-[15px] h-[15px]" alt="edit icon" />
              </div>
            )}
          </h2>
        </div>
        <SliderWrapper>
          <Slider {...settings} ref={sliderRef}>
            {data?.parent_card?.map((item, index) => (
              <Card
                key={index}
                itemId={`index${index}`}
                index={index}
                cardInfo={item}
                isEdit={isEdit}
                hoverState={hoverState}
                theme={theme}
                handleHoverItems={handleHoverItems}
                handleModal={handleModal}
                deleteCard={deleteCard}
                getTemplateImage={getTemplateImage}
                getStyleValue={getStyleValue}
              />
            ))}
          </Slider>
        </SliderWrapper>
      </div>
      {isEdit && hoverState.length > 0 && <AddSection openAdd={handleAddModal} />}

      {deleteModal && (
        <DeleteModal
          openModal={deleteModal}
          title={`Are you sure you want to delete this Card ?`}
          confirmButtonText={`Yes`}
          onCancel={() => {
            setSelectedCardIndex('')
            setDeleteModal(false)
          }}
          onConfirm={onDeleteCard}
        />
      )}
    </div>
  )
}

function Card({
  index,
  cardInfo,
  isEdit,
  hoverState,
  theme,
  handleHoverItems,
  handleModal,
  deleteCard,
  getTemplateImage,
  getStyleValue,
}) {
  const { PlusIcon, EditIcon, TrashIcon, customNavigate } = useTemplateHook()

  const handleRedirect = (linkObj) => {
    customNavigate('INDIRECT', linkObj, isEdit)
  }

  return (
    <div key={index} className={`flex cursor-pointer`}>
      <div
        className={`p-1 flex-shrink-0   md:h-[33rem] xl:w-[24.5625rem] md:w-[22.5625rem] lg:w-[19.5625rem]   xl:h-[34.12500rem] ${
          isEdit && hoverState === `CARD${index}` && 'component-hover-class'
        } `}
        onMouseOver={(e) => {
          e.stopPropagation()
          handleHoverItems(`CARD${index}`)
        }}
        onMouseLeave={(e) => {
          e.stopPropagation()
          handleHoverItems('TOP')
        }}
        style={{
          background: getStyleValue('parent_card_style', 'parent_card_background', ''),
        }}
      >
        {isEdit && hoverState === `CARD${index}` && (
          <div style={{ zIndex: 25 }} className={`relative `}>
            <div className={`absolute w-full top-0 right-4  flex justify-end items-center`}>
              <div
                className="mx-[8px] h-[32px] w-[32px] rounded-full bg-[#2172eb] flex justify-center items-center cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation()
                  handleModal(cardInfo, 'CARD', index, true)
                }}
              >
                <img src={EditIcon} className="w-[17px] h-[17px]" alt="editicon" />
              </div>
              <div
                className="mx-[8px] h-[32px] w-[32px] rounded-full bg-[#2172eb] flex justify-center items-center cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation()
                  deleteCard(index)
                }}
              >
                <img src={TrashIcon} className="w-[17px] h-[17px]" alt="trashicon" />
              </div>
            </div>
          </div>
        )}
        {/* Header */}
        <div className="flex items-center justify-between mt-5 px-3 mb-5">
          <h2
            className={`font-semibold text-base w-full ${getStyleValue(
              'parent_card_style',
              'font_format',
              '',
            )}`}
            style={{
              color: getStyleValue('parent_card_style', 'parent_card_heading', ''),
              fontFamily: getStyleValue('parent_card_style', 'font', ''),
              textAlign: getStyleValue('parent_card_style', 'alignment', ''),
            }}
          >
            {cardInfo.parent_heading}
          </h2>
          <div onClick={() => handleRedirect(cardInfo.parent_link)}>
            <NextArrow color={getStyleValue('parent_card_style', 'parent_card_heading', '')} />
          </div>
        </div>

        {/* 2x2 grid */}
        <div className="grid grid-cols-2  gap-x-6 px-3">
          {Object.values(cardInfo?.child_card).map((item) => (
            <div key={item.id} className="flex flex-col" onClick={() => handleRedirect(item.link)}>
              <CustomImage
                imageUrl={getTemplateImage(item?.image_s3key)}
                imgAlt={item.card_heading}
                imgClass={`w-[115px] h-[115px] md:w-36 md:h-36  xl:w-40 xl:h-40 object-cover rounded`}
              />
              <div className="flex flex-col" style={{ minHeight: '80px' }}>
                <p
                  className={`text-[10px]  sm:text-sm xl:text-base line-clamp-2 ${getStyleValue(
                    'child_card_style',
                    'child_heading_font_format',
                    '',
                  )}`}
                  style={{
                    color: getStyleValue('child_card_style', 'child_card_heading', ''),
                    fontFamily: getStyleValue('child_card_style', 'child_heading_font', ''),
                    textAlign: getStyleValue('child_card_style', 'child_heading_alignment', ''),
                    maxWidth: '160px',
                  }}
                >
                  {item.card_heading}
                </p>
                <p
                  className={`text-[10px]  sm:text-sm font-semibold ${getStyleValue(
                    'child_card_style',
                    'child_sub_font_format',
                    '',
                  )}`}
                  style={{
                    color: getStyleValue('child_card_style', 'child_card_sub_heading', ''),
                    fontFamily: getStyleValue('child_card_style', 'child_sub_font', ''),
                    textAlign: getStyleValue('child_card_style', 'child_sub_alignment', ''),
                  }}
                >
                  {item.card_sub_heading}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {isEdit && (
        <div className="rosemary-toptrending-add-button d-flex justify-content-center align-items-center py-2 ">
          <div style={{ border: '1px solid #2172eb' }} className="relative h-full ml-5 mr-5">
            <div
              onClick={(e) => {
                e.stopPropagation()
                handleModal({}, 'CARD', index, false)
              }}
              className="absolute h-[32px] w-[32px] rounded-full bg-[#2172eb] top-[45%] -left-4 flex justify-center items-center cursor-pointer"
            >
              <img src={PlusIcon} className="w-[17px] h-[17px]" alt="plus icon" />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default QuadruplePromoCarousel
